import { useState, useCallback, useMemo } from 'react';

export function useTableSort(defaultField = null, defaultDirection = 'asc') {
  const [sortField, setSortField] = useState(defaultField);
  const [sortDirection, setSortDirection] = useState(defaultDirection);

  const handleSort = useCallback((field) => {
    setSortField((prev) => {
      if (prev === field) {
        setSortDirection((d) => (d === 'asc' ? 'desc' : 'asc'));
        return prev;
      }
      setSortDirection('asc');
      return field;
    });
  }, []);

  const sortIcon = useCallback((field) => {
    if (sortField !== field) return '';
    return sortDirection === 'asc' ? ' \u25B2' : ' \u25BC';
  }, [sortField, sortDirection]);

  const sortableHeader = useCallback((label, field) => (
    <th style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }} onClick={() => handleSort(field)}>
      {label}{sortIcon(field)}
    </th>
  ), [handleSort, sortIcon]);

  const sortData = useCallback((data, dateFields = []) => {
    if (!sortField || !data) return data;
    return [...data].sort((a, b) => {
      let va = a[sortField] ?? '';
      let vb = b[sortField] ?? '';

      if (dateFields.includes(sortField)) {
        va = new Date(va).getTime() || 0;
        vb = new Date(vb).getTime() || 0;
      } else if (typeof va === 'number' && typeof vb === 'number') {
        // numeric compare
      } else {
        va = String(va).toLowerCase();
        vb = String(vb).toLowerCase();
      }

      if (va < vb) return sortDirection === 'asc' ? -1 : 1;
      if (va > vb) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }, [sortField, sortDirection]);

  return {
    sortField,
    sortDirection,
    handleSort,
    sortIcon,
    sortableHeader,
    sortData,
  };
}
